export class CertificadoUnidade {

	id:number;
	codigo:String;
	descricao:String;
	dataInicio:Date;
	dataFim:Date;
}

